export default __webpack_public_path__ + "static/media/electricity-yes.6a81c858.png";